import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  // Three columns is the portal's form layout (§6.2). These four fields are
  // short — a category key, an enum, a locale tag, an integer — so a full-width
  // stack would leave most of each row empty.
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  submit: {
    marginTop: theme.spacing(2)
  }
}))
